/* eslint-disable @typescript-eslint/no-explicit-any */

function gtag(...args: unknown[]): void {
  if (typeof window !== 'undefined' && typeof (window as any).gtag === 'function') {
    (window as any).gtag(...args);
  }
}

export function grantConsent(): void {
  gtag('consent', 'update', { analytics_storage: 'granted' });
}

export function denyConsent(): void {
  gtag('consent', 'update', { analytics_storage: 'denied' });
}

export function trackEvent(name: string, params?: Record<string, unknown>): void {
  gtag('event', name, params);
}
